import { render, staticRenderFns } from "./VersionAdd.vue?vue&type=template&id=8c318d90&scoped=true"
import script from "./VersionAdd.vue?vue&type=script&lang=ts"
export * from "./VersionAdd.vue?vue&type=script&lang=ts"
import style0 from "./VersionAdd.vue?vue&type=style&index=0&id=8c318d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c318d90",
  null
  
)

export default component.exports